<template>
  <!-- Someone in the support chat: their picture or logo when there is one
       that loads, else their initials on a tint of their own, with a green
       dot while they are online. -->
  <span
    class="sc-avatar"
    :class="[`sc-avatar--t${tone}`, { 'sc-avatar--image': showImage, 'sc-avatar--square': square }]"
    :style="{ width: `${size}px`, height: `${size}px`, fontSize: `${Math.round(size * 0.38)}px` }"
    aria-hidden="true"
  >
    <img v-if="showImage" :src="image" alt="" loading="lazy" @error="failed = true" />
    <template v-else>{{ initials }}</template>
    <span v-if="online" class="sc-avatar__online"></span>
  </span>
</template>
<script>
import { chatAvatarTone, chatInitials } from '@/utils/chat';

export default {
  name: 'ChatAvatar',
  props: {
    name: {
      type: String,
      default: '',
    },
    image: {
      type: String,
      default: '',
    },
    size: {
      type: Number,
      default: 40,
    },
    online: {
      type: Boolean,
      default: false,
    },
    // A logo sits in a rounded square rather than a circle.
    square: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      failed: false,
    };
  },
  computed: {
    showImage() {
      return Boolean(this.image) && !this.failed;
    },
    initials() {
      return chatInitials(this.name);
    },
    tone() {
      return chatAvatarTone(this.name);
    },
  },
  watch: {
    image() {
      this.failed = false;
    },
  },
};
</script>
